import { stagger, timeline, inView } from "motion";

const elm = document.querySelector('.rewards-cards-fan');

const timing = {
  delay: stagger(0.1),
  easing: 'ease-in-out',
  duration: 0.5,
  at: '<'
};

const sequence = [
  [
    '.rewards-cards-fan', {opacity: 1}, {duration: 0.2}
  ],
  [
    '[data-animate-card="1"]',
    { y: ["7%", "-8%"], x: ["-54%", "-112%"], rotate: ["-6deg", "-39deg"] },
    timing
  ],
  [
    '[data-animate-card="2"]',
    { y: ["14%", "-16%"], x: ["-53%", "-65%"], rotate: ["-2deg", "-20deg"] },
    timing
  ],
  [
    '[data-animate-card="3"]',
    { y: ["11%", "-17%"], x: ["-52%", "-17%"], rotate: ["1deg", "1deg"] },
    timing
  ],
  [
    '[data-animate-card="4"]',
    { y: ["7%", "-8%"], x: ["-51%", "31%"], rotate: ["6deg", "21deg"] },
    timing
  ],
];

window.addEventListener("DOMContentLoaded", () => {
  if (animationsEnabled) {
    inView('.rewards-cards-wrapper', () => {
      timeline(sequence);
    });
  } else {
    elm.style.opacity = 1;
  }
});
